import React from 'react';
import { CommonReadonly } from '@warehouse/title/core';
import { ContentField } from './ui/ContentField';
import { DeleteButtonField } from './ui/DeleteButtonField';
import { RelationshipTypeField } from './ui/RelationshipTypeField';
import { ParentField } from './ui/ParentField';
import { ContentRelatedToPrimaryField } from './ui/ContentRelatedToPrimaryField';

export function ContentRelatedToRelationshipEditor({
	parentTitle,
	childTitle,
	primary,
	deleteChild,
	commitChanges,
	updatePrimary,
}: ContentRelatedToRelationshipEditorLoaderProps) {
	return (
		<>
			<ContentField titleLight={childTitle} />
			<RelationshipTypeField relationshipType="Related to" />
			<ParentField titleLight={parentTitle} />
			<ContentRelatedToPrimaryField primary={primary} onPrimaryChange={updatePrimary} onBlur={commitChanges} />
			<DeleteButtonField onDelete={deleteChild} />
		</>
	);
}

interface ContentRelatedToRelationshipEditorLoaderProps {
	parentTitle: CommonReadonly;
	childTitle: CommonReadonly;
	primary: boolean;
	deleteChild: () => void;
	commitChanges: () => void;
	updatePrimary: (primary: boolean) => void;
}
